import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "@environments/environment";
import { RequestHelper } from "@helper/request.helper";
import { IndodanaService } from "../service/indodana.service";


@Component({
    selector: 'app-indodana-auth',
    templateUrl: './indodanaauth.component.html',
    styleUrls: ['./indodanaauth.component.css']
})
export class IndodanaAuthComponent implements OnInit{    
    form: FormGroup;
    isSubmitted: boolean;
    hostname: any = environment.hostName;
    imgUri : string;
    maxLength: number = 13;
    orderId: string;
    amount: number;
    isPaymentFailed: string;
    callbackUri: string;
    bindingInvoiceNumber : string;
    bindingAmount: string;
    uriCallBack: string;

    constructor(private router:Router,
        private route:ActivatedRoute,
        private indodanaService:IndodanaService,
        private apiService:RequestHelper
        ){
        this.isSubmitted = false;
    }

    ngOnInit(): void {
        console.log("indodana starter");
        this.imgUri = "https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/financing/indodana.png"
        this.doValidateUriPayment();
        this.form = new FormBuilder().group({
            phoneNumber: [null, [Validators.required, Validators.maxLength(this.maxLength)]],
            password: [null, [Validators.required]]
        })
    }

    doLogin(){
        this.isSubmitted=false;
        if (this.form.controls["phoneNumber"].value == "0812000000" && this.form.controls["password"].value == "123456"){
            console.log("password and phone number true")
            if(!this.form.valid){
                console.log("login failed")
                this.isSubmitted=true;
                return;
            }else{
                console.log("success login")
                this.router.navigate(['/paylater-indodana-inquiry', {
                    numberRef: this.orderId
                }])
            }
        }else if (this.form.controls["phoneNumber"].value == "0812000000" && this.form.controls["password"].value == "111111") {
            console.log("payment failed !");
            this.doFailedPayment();
            // seharusnya ketika step ini kirim notification ke core akulaku dengan status 90
        }else{
            console.log("password and phone number wrong");
            this.openDialog("PASSWORD AND PHONE NUMBER WRONG");
        }
    }

    doFailedPayment(){
        var data = {
            "merchantOrderId" : localStorage.getItem('indodana_orderid'),
            "password" : "111111"
        }
        this.indodanaService.submitPayment(data).subscribe(response => {
            console.log("response failed payment "+JSON.stringify(response));
            if (response["status"] == "OK"){
                this.isPaymentFailed = "2";
            }
        })
    }

    openDialog(result){
        this.apiService.openDialog(result, '/indodana/payment');
    }

    doValidateUriPayment(){
        this.route.queryParams
            .subscribe(params => {
                console.log("params -> "+JSON.stringify(params));
                console.log("order id -> "+params.orderId);
                console.log("amount -> "+params.amount)
                if (params.orderId != null && params.amount != null){
                    localStorage.setItem('indodana_amont', params.amount);
                    localStorage.setItem('indodana_orderid', params.orderId);
                }

                console.log("order id from localstorage -> "+localStorage.getItem('indodana_orderid'));
                console.log("amount from localstoraga -> "+localStorage.getItem("indodana_amount"));
                this.orderId = localStorage.getItem('indodana_orderid') == null ? params.orderId : localStorage.getItem('indodana_orderid');
                this.amount = localStorage.getItem('indodana_amont') == null ? params.amount : localStorage.getItem('indodana_amont');
                console.log("order id to binding -> "+this.orderId);
                var checkOrderId = localStorage.getItem('indodana_orderid') == null ? params.orderId : localStorage.getItem('indodana_orderid');
                this.indodanaService.validationPayment(checkOrderId)
                    .subscribe(response => {
                        console.log("response validate payment -> "+JSON.stringify(response));
                        if (response['status'] == "NEW"){
                            console.log("payment not yet paid")
                            console.log("uri callback -> "+response['backToStoreUrl'])
                            localStorage.setItem('indodana_uri_callback', response['backToStoreUrl'])
                            this.isPaymentFailed='0';
                        }else if (response['status'] == "SUCCESS"){
                            console.log("payment already paid")
                            this.isPaymentFailed ='1';
                        }else {
                            console.log("payment failed");
                            this.isPaymentFailed ='2';
                        }
                        console.log("payment failed -> "+this.isPaymentFailed);
                    }, error => console.log("error from backend "+error))
            })
    }

    previousPage(){
        // TODO : untuk step payment done / payment success seharusnya redirect url nya dari param 'callbackPageUrl' ketika create order, bukan kembali ke halaman payment instruction
        //this.router.navigate(['/paylater-akulaku']);
        window.location.href=localStorage.getItem('indodana_uri_callback');
    }
}
